/* eslint-disable max-len */
import React, { Fragment } from 'react';
import createSvgIcon from '../../utils/createSvgIcon';
import { palette } from '../themes/vad/palette';

export const Blizzard = createSvgIcon(
  <Fragment>
    <defs>
      <polygon id="path-1" points="0 0.0004 32 0.0004 32 26 0 26"></polygon>
    </defs>
    <g
      id="Homepage_image-ratio-fixed"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
        transform="translate(-1098.000000, -468.000000)"
      >
        <g id="Group-46" transform="translate(207.000000, 368.000000)">
          <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
            <g id="Blizzard-40x40" transform="translate(887.399700, 93.464300)">
              <g id="Group-3" transform="translate(4.000000, 7.000000)">
                <mask id="mask-2" fill="white">
                  <use href="#path-1"></use>
                </mask>
                <g id="Clip-2"></g>
                <path
                  d="M8,18.0004 L8,20.0004 L11,20.0004 C11.566,20.0004 12,20.4344 12,21.0004 C12,21.5664 11.566,22.0004 11,22.0004 C10.625,22.0004 10.309,21.8014 10.137,21.5004 L8.406,22.5124 C8.93,23.3984 9.902,24.0004 11,24.0004 C12.645,24.0004 14,22.6454 14,21.0004 C14,20.6484 13.926,20.3164 13.812,20.0004 L19,20.0004 C20.117,20.0004 21,20.8834 21,22.0004 C21,23.1174 20.117,24.0004 19,24.0004 C18.121,24.0004 17.387,23.4374 17.113,22.6644 L15.227,23.3284 C15.777,24.8914 17.266,26.0004 19,26.0004 C21.199,26.0004 23,24.1994 23,22.0004 C23,19.8014 21.199,18.0004 19,18.0004 L8,18.0004 Z M15.5,9.0004 C14.363,9.0004 13.34,9.5514 12.703,10.3984 L14.301,11.5984 C14.574,11.2344 15.004,11.0004 15.5,11.0004 C16.34,11.0004 17,11.6604 17,12.5004 C17,13.3404 16.34,14.0004 15.5,14.0004 L9,14.0004 L9,16.0004 L15.5,16.0004 C17.422,16.0004 19,14.4224 19,12.5004 C19,10.5784 17.422,9.0004 15.5,9.0004 L15.5,9.0004 Z M16,0.0004 C12.773,0.0004 9.957,2.2584 9.203,5.3444 C7.957,5.8284 6.949,6.7974 6.418,8.0164 C2.922,7.7584 0,10.5554 0,14.0004 C0,17.3094 2.691,20.0004 6,20.0004 L6,18.0004 C3.793,18.0004 2,16.2074 2,14.0004 C2,11.7934 3.793,10.0004 6,10.0004 C6.277,10.0004 6.566,10.0354 6.883,10.1054 L7.859,10.3284 L8.078,9.3484 C8.32,8.2424 9.199,7.3554 10.305,7.0944 L10.965,6.9374 L11.063,6.2664 C11.418,3.8324 13.543,2.0004 16,2.0004 C17.895,2.0004 19.605,3.0554 20.461,4.7504 L20.855,5.5314 L21.684,5.2424 C22.152,5.0824 22.582,5.0004 23,5.0004 C25.207,5.0004 27,6.7934 27,9.0004 C27,9.0394 26.992,9.0744 26.984,9.1094 C26.977,9.1804 26.969,9.2504 26.965,9.3164 L26.902,10.0354 L27.566,10.3204 C29.047,10.9494 30,12.3954 30,14.0004 C30,16.2074 28.207,18.0004 26,18.0004 L23.457,18.0004 C23.719,18.2894 23.949,18.6024 24.148,18.9374 C24.348,19.2734 24.516,19.6294 24.648,20.0004 L26,20.0004 C29.309,20.0004 32,17.3134 32,14.0004 C32,11.8364 30.84,9.8674 28.996,8.8014 C28.891,5.5864 26.242,3.0004 23,3.0004 C22.609,3.0004 22.223,3.0434 21.828,3.1254 C20.535,1.1804 18.371,0.0004 16,0.0004 L16,0.0004 Z"
                  fill={palette.common.White}
                  mask="url(#mask-2)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Fragment>,
  'Blizzard',
  '0 0 33 27'
);

export const BlowingSnow = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-507.000000, -372.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Blowing-Snow-40x40"
            transform="translate(295.000000, 0.000000)"
          >
            <g transform="translate(5.000000, 4.000000)">
              <polygon
                id="Fill-22"
                points="23.25 2.7000624e-13 23.25 4.375 19.542 2.166 18.167 4.5 21.875 6.666 18.167 8.833 19.542 11.166 23.25 8.958 23.25 13.333 25.917 13.333 25.917 8.958 29.625 11.166 31 8.833 27.292 6.666 31 4.5 29.625 2.166 25.917 4.375 25.917 2.7000624e-13"
              ></polygon>
              <polygon
                id="Fill-24"
                points="8.583 2.666 8.583 5.708 5.917 4.166 4.583 6.5 7.25 8 4.583 9.5 5.917 11.833 8.583 10.291 8.583 13.333 11.25 13.333 11.25 10.291 13.917 11.833 15.25 9.5 12.583 8 15.25 6.5 13.917 4.166 11.25 5.708 11.25 2.666"
              ></polygon>
              <polygon
                id="Fill-30"
                points="3.417 15.333 3.417 17.916 1.167 16.583 6.25277607e-13 18.625 2.417 20 6.25277607e-13 21.375 1.167 23.416 3.417 22.083 3.417 24.666 5.75 24.666 5.75 22.083 8 23.416 9.167 21.375 6.75 20 9.167 18.625 8 16.583 5.75 17.916 5.75 15.333"
              ></polygon>
              <polygon
                id="Fill-34"
                points="11.083 23.333 11.083 25.291 9.375 24.333 8.583 25.791 10.125 26.666 8.583 27.541 9.375 29 11.083 28.041 11.083 30 12.75 30 12.75 28.041 14.458 29 15.25 27.541 13.708 26.666 15.25 25.791 14.458 24.333 12.75 25.291 12.75 23.333"
              ></polygon>
              <polygon
                id="Fill-36"
                points="20.417 24.666 20.417 26.625 18.708 25.666 17.917 27.125 19.458 28 17.917 28.875 18.708 30.333 20.417 29.375 20.417 31.333 22.083 31.333 22.083 29.375 23.792 30.333 24.583 28.875 23.042 28 24.583 27.125 23.792 25.666 22.083 26.625 22.083 24.666"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'BlowingSnow',
  '0 0 31 32'
);

export const Cloudy = createSvgIcon(
  <Fragment>
    <g
      id="Homepage_image-ratio-fixed"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
        transform="translate(-578.000000, -377.000000)"
        fill={palette.common.White}
      >
        <g id="Group-46" transform="translate(207.000000, 368.000000)">
          <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
            <g id="Cloudy-40x40" transform="translate(367.000000, 0.000000)">
              <path
                d="M18.667,11.667 C22.349,11.667 25.297,14.026 26.333,17.375 L26.625,18.333 L28,18.333 C31.036,18.333 33.333,20.63 33.333,23.667 C33.333,26.703 31.036,29 28,29 L12,29 C8.964,29 6.667,26.703 6.667,23.667 C6.667,21.417 8.052,19.5 10.125,18.625 L10.75,18.375 L10.917,17.708 C11.703,14.328 14.886,11.667 18.667,11.667 M18.667,9 C13.875,9 9.844,12.192 8.542,16.5 C5.864,17.875 4,20.536 4,23.667 C4,28.099 7.567,31.667 12,31.667 L28,31.667 C32.433,31.667 36,28.099 36,23.667 C36,19.396 32.661,16 28.458,15.75 C26.855,11.844 23.172,9 18.667,9"
                id="Fill-42"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Fragment>,
  'Cloudy',
  '0 0 32 23'
);

export const Fog = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-221.000000, -467.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g id="Fog-40x40" transform="translate(5.000000, 90.429500)">
            <path d="M11.667,18.0003 L27,18.0003 L27,15.3343 L11.667,15.3343 L11.667,18.0003 Z M9,24.3343 L29.667,24.3343 L29.667,21.6663 L9,21.6663 L9,24.3343 Z M31,27.9993 L31,30.6663 L11.667,30.6663 L11.667,27.9993 L31,27.9993 Z M30.9999,9 L30.9999,11.667 L18.6669,11.667 L18.6669,9 L30.9999,9 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'Fog',
  '0 0 22 23'
);

export const FreezingDrizzle = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-949.000000, -540.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Frezzing-Drizzle-40x40"
            transform="translate(738.072403, 166.901500)"
          >
            <g transform="translate(4.000000, 6.000000)">
              <path
                d="M14.6671967,1.84741111e-13 C9.87519671,1.84741111e-13 5.84419671,3.193 4.54219671,7.5 C1.32019671,9.155 -0.724803289,12.672 0.240196711,16.627 C1.12119671,20.24 4.53519671,22.667 8.25519671,22.667 L9.33319671,22.667 L9.33319671,20 L8.19819671,20 C5.58819671,20 3.20219671,18.215 2.75319671,15.645 C2.28719671,12.982 3.75819671,10.625 6.12519671,9.625 L6.75019671,9.375 L6.91719671,8.709 C7.70319671,5.328 10.8861967,2.667 14.6671967,2.667 C18.3491967,2.667 21.4271967,5.089 22.3331967,8.375 L22.5831967,9.334 L23.9071967,9.334 C26.5361967,9.334 28.9041967,11.19 29.2711967,13.793 C29.7591967,17.252 27.3221967,20 24.0001967,20 L22.6671967,20 L22.6671967,22.667 L23.7211967,22.667 C27.7871967,22.667 31.4241967,19.753 31.9341967,15.718 C32.5341967,10.966 29.0011967,7.021 24.4581967,6.75 C22.9381967,2.803 19.1671967,1.84741111e-13 14.6671967,1.84741111e-13"
                id="Fill-16"
              ></path>
              <polygon
                id="Fill-17"
                points="17.5050967 11.6368 17.5050967 13.3018 16.0530967 12.4868 15.3800967 13.7268 16.6910967 14.4698 15.3800967 15.2138 16.0530967 16.4528 17.5050967 15.6388 17.5050967 17.3038 18.9220967 17.3038 18.9220967 15.6388 20.3740967 16.4528 21.0470967 15.2138 19.7360967 14.4698 21.0470967 13.7268 20.3740967 12.4868 18.9220967 13.3018 18.9220967 11.6368"
              ></polygon>
              <path
                d="M17.9445967,24.6084 L17.9445967,24.6084 C17.3095967,24.6084 16.7965967,25.1234 16.7965967,25.7574 L16.7965967,26.5234 C16.7965967,27.1574 17.3095967,27.6714 17.9445967,27.6714 C18.5785967,27.6714 19.0925967,27.1574 19.0925967,26.5234 L19.0925967,25.7574 C19.0925967,25.1234 18.5785967,24.6084 17.9445967,24.6084"
                id="Fill-18"
              ></path>
              <path
                d="M16.0304967,19.6319 L16.0304967,19.6319 C15.3954967,19.6319 14.8824967,20.1459 14.8824967,20.7799 L14.8824967,21.5459 C14.8824967,22.1809 15.3954967,22.6949 16.0304967,22.6949 C16.6644967,22.6949 17.1784967,22.1809 17.1784967,21.5459 L17.1784967,20.7799 C17.1784967,20.1459 16.6644967,19.6319 16.0304967,19.6319"
                id="Fill-19"
              ></path>
              <path
                d="M20.0304967,19.6319 L20.0304967,19.6319 C19.3954967,19.6319 18.8824967,20.1459 18.8824967,20.7799 L18.8824967,21.5459 C18.8824967,22.1809 19.3954967,22.6949 20.0304967,22.6949 C20.6644967,22.6949 21.1784967,22.1809 21.1784967,21.5459 L21.1784967,20.7799 C21.1784967,20.1459 20.6644967,19.6319 20.0304967,19.6319"
                id="Fill-20"
              ></path>
              <path
                d="M11.9699967,19.6319 L11.9699967,19.6319 C11.3359967,19.6319 10.8219967,20.1459 10.8219967,20.7799 L10.8219967,21.5459 C10.8219967,22.1809 11.3359967,22.6949 11.9699967,22.6949 C12.6049967,22.6949 13.1179967,22.1809 13.1179967,21.5459 L13.1179967,20.7799 C13.1179967,20.1459 12.6049967,19.6319 11.9699967,19.6319 M13.8849967,24.6089 L13.8849967,24.6089 C13.2499967,24.6089 12.7359967,25.1229 12.7359967,25.7579 L12.7359967,26.5239 C12.7359967,27.1569 13.2499967,27.6719 13.8849967,27.6719 C14.5189967,27.6719 15.0329967,27.1569 15.0329967,26.5239 L15.0329967,25.7579 C15.0329967,25.1229 14.5189967,24.6089 13.8849967,24.6089"
                id="Fill-21"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'FreezingDrizzle',
  '0 0 33 29'
);

export const FreezingFog = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-350.000000, -542.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Freezing-Fog-40x40"
            transform="translate(140.189300, 167.465000)"
          >
            <g id="Group" transform="translate(3.000000, 7.000000)">
              <path
                d="M4.083,6.2129 L-6.39488462e-13,6.2129 L-6.39488462e-13,8.8799 L9.333,8.8799 L9.333,6.2129 L4.083,6.2129 M8.333,16.8799 L-6.39488462e-13,16.8799 L-6.39488462e-13,19.5469 L8.333,19.5469"
                id="Fill-4"
              ></path>
              <polygon
                id="Fill-8"
                points="22.1465 0 22.1465 2.683 20.8055 1.342 19.3005 2.847 22.1465 5.692 22.1465 10.73 17.6975 8.179 16.6835 4.351 14.6555 4.874 15.1465 6.706 12.8235 5.365 11.7765 7.197 14.0995 8.538 12.2345 9.029 12.7915 11.058 16.6835 10.011 21.0665 12.562 16.6835 15.113 12.7915 14.066 12.2345 16.095 14.0995 16.586 11.7765 17.927 12.8235 19.759 15.1465 18.417 14.6555 20.249 16.6835 20.772 17.6975 16.945 22.1465 14.394 22.1465 19.432 19.3005 22.277 20.8055 23.782 22.1465 22.441 22.1465 25.123 24.2405 25.123 24.2405 22.441 25.5815 23.782 27.0855 22.277 24.2405 19.432 24.2405 14.394 28.6885 16.945 29.7035 20.772 31.7315 20.249 31.2405 18.417 33.5635 19.759 34.6095 17.927 32.2875 16.586 34.1515 16.095 33.5955 14.066 29.7035 15.113 25.3195 12.562 29.7035 10.011 33.5955 11.058 34.1515 9.029 32.2875 8.538 34.6095 7.197 33.5635 5.365 31.2405 6.706 31.7315 4.874 29.7035 4.351 28.6885 8.179 24.2405 10.73 24.2405 5.692 27.0855 2.847 25.5815 1.342 24.2405 2.683 24.2405 0"
              ></polygon>
              <polyline
                id="Fill-6"
                points="7.333 11.5469 2.7000624e-13 11.5469 2.7000624e-13 14.2129 7.333 14.2129"
              ></polyline>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'FreezingFog',
  '0 0 35 26'
);

export const HeavyFreezingDrizzle = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-1169.000000, -822.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Heavy-Freezing-Drizzle-40x40"
            transform="translate(958.000000, 447.971800)"
          >
            <g transform="translate(4.000000, 6.000000)">
              <path
                d="M14.6668466,1.84741111e-13 C9.87484665,1.84741111e-13 5.84384665,3.193 4.54184665,7.5 C1.31984665,9.155 -0.72415335,12.672 0.23984665,16.627 C1.12084665,20.24 4.53484665,22.667 8.25484665,22.667 L9.33384665,22.667 L9.33384665,20 L8.19784665,20 C5.58784665,20 3.20184665,18.215 2.75284665,15.645 C2.28684665,12.982 3.75784665,10.625 6.12484665,9.625 L6.74984665,9.375 L6.91684665,8.709 C7.70284665,5.328 10.8858466,2.667 14.6668466,2.667 C18.3498466,2.667 21.4278466,5.089 22.3338466,8.375 L22.5838466,9.334 L23.9068466,9.334 C26.5358466,9.334 28.9038466,11.19 29.2708466,13.793 C29.7588466,17.252 27.3218466,20 23.9998466,20 L22.6668466,20 L22.6668466,22.667 L23.7208466,22.667 C27.7878466,22.667 31.4238466,19.753 31.9338466,15.718 C32.5338466,10.966 29.0008466,7.021 24.4588466,6.75 C22.9378466,2.803 19.1668466,1.84741111e-13 14.6668466,1.84741111e-13"
                id="Fill-22"
              ></path>
              <polygon
                id="Fill-23"
                points="17.5047466 11.6368 17.5047466 13.3018 16.0527466 12.4868 15.3797466 13.7268 16.6907466 14.4698 15.3797466 15.2138 16.0527466 16.4528 17.5047466 15.6388 17.5047466 17.3038 18.9217466 17.3038 18.9217466 15.6388 20.3737466 16.4528 21.0467466 15.2138 19.7357466 14.4698 21.0467466 13.7268 20.3737466 12.4868 18.9217466 13.3018 18.9217466 11.6368"
              ></polygon>
              <path
                d="M15.9139466,24.6084 L15.9139466,24.6084 C15.2799466,24.6084 14.7659466,25.1234 14.7659466,25.7574 L14.7659466,26.5234 C14.7659466,27.1574 15.2799466,27.6714 15.9139466,27.6714 C16.5489466,27.6714 17.0629466,27.1574 17.0629466,26.5234 L17.0629466,25.7574 C17.0629466,25.1234 16.5489466,24.6084 15.9139466,24.6084"
                id="Fill-24"
              ></path>
              <path
                d="M20.0301466,24.6084 L20.0301466,24.6084 C19.3951466,24.6084 18.8821466,25.1234 18.8821466,25.7574 L18.8821466,26.5234 C18.8821466,27.1574 19.3951466,27.6714 20.0301466,27.6714 C20.6641466,27.6714 21.1781466,27.1574 21.1781466,26.5234 L21.1781466,25.7574 C21.1781466,25.1234 20.6641466,24.6084 20.0301466,24.6084"
                id="Fill-25"
              ></path>
              <path
                d="M16.0301466,19.6319 L16.0301466,19.6319 C15.3951466,19.6319 14.8821466,20.1459 14.8821466,20.7799 L14.8821466,21.5459 C14.8821466,22.1809 15.3951466,22.6949 16.0301466,22.6949 C16.6641466,22.6949 17.1781466,22.1809 17.1781466,21.5459 L17.1781466,20.7799 C17.1781466,20.1459 16.6641466,19.6319 16.0301466,19.6319"
                id="Fill-26"
              ></path>
              <path
                d="M20.0301466,19.6319 L20.0301466,19.6319 C19.3951466,19.6319 18.8821466,20.1459 18.8821466,20.7799 L18.8821466,21.5459 C18.8821466,22.1809 19.3951466,22.6949 20.0301466,22.6949 C20.6641466,22.6949 21.1781466,22.1809 21.1781466,21.5459 L21.1781466,20.7799 C21.1781466,20.1459 20.6641466,19.6319 20.0301466,19.6319"
                id="Fill-27"
              ></path>
              <path
                d="M11.9705466,19.6319 L11.9705466,19.6319 C11.3355466,19.6319 10.8215466,20.1459 10.8215466,20.7799 L10.8215466,21.5459 C10.8215466,22.1809 11.3355466,22.6949 11.9705466,22.6949 C12.6045466,22.6949 13.1185466,22.1809 13.1185466,21.5459 L13.1185466,20.7799 C13.1185466,20.1459 12.6045466,19.6319 11.9705466,19.6319 M11.8545466,24.6089 L11.8545466,24.6089 C11.2195466,24.6089 10.7055466,25.1229 10.7055466,25.7579 L10.7055466,26.5239 C10.7055466,27.1569 11.2195466,27.6719 11.8545466,27.6719 C12.4895466,27.6719 13.0025466,27.1569 13.0025466,26.5239 L13.0025466,25.7579 C13.0025466,25.1229 12.4895466,24.6089 11.8545466,24.6089"
                id="Fill-28"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'HeavyFreezingDrizzle',
  '0 0 32 28'
);

export const HeavyRain = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-433.000000, -374.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g id="Heavy-Rain-40x40" transform="translate(222.000000, 0.000000)">
            <path d="M24,20.851 L24,33.817 C24,33.918 24.082,34 24.184,34 L26.483,34 C26.584,34 26.667,33.918 26.667,33.817 L26.667,20.851 C26.667,20.749 26.584,20.667 26.483,20.667 L24.184,20.667 C24.082,20.667 24,20.749 24,20.851 M13.333,20.851 L13.333,33.817 C13.333,33.918 13.416,34 13.517,34 L15.816,34 C15.917,34 16,33.918 16,33.817 L16,20.851 C16,20.749 15.917,20.667 15.816,20.667 L13.517,20.667 C13.416,20.667 13.333,20.749 13.333,20.851 M18.667,18.184 L18.667,31.15 C18.667,31.251 18.749,31.334 18.85,31.334 L21.149,31.334 C21.251,31.334 21.333,31.251 21.333,31.15 L21.333,18.184 C21.333,18.082 21.251,18 21.149,18 L18.85,18 C18.749,18 18.667,18.082 18.667,18.184 M18.667,6 C13.9,6 9.886,9.161 8.562,13.434 C8.549,13.477 8.519,13.512 8.479,13.533 C5.835,14.917 4,17.561 4,20.667 C4,25.035 7.464,28.563 11.806,28.6650338 C11.911,28.667 12,28.58 12,28.475 L12,26.176 C12,26.078 11.921,26.001 11.823,25.998 C8.875,25.911 6.667,23.645 6.667,20.667 C6.667,18.417 8.052,16.5 10.125,15.625 L10.75,15.375 L10.917,14.709 C11.703,11.329 14.885,8.667 18.667,8.667 C22.349,8.667 25.297,11.027 26.333,14.375 L26.625,15.334 L27.658,15.334 C31.005,15.334 33.78,18.255 33.265,21.563 C32.871,24.088 30.822,25.919 28.177,25.998 C28.079,26.001 28,26.078 28,26.175 L28,28.475 C28,28.58 28.089,28.667 28.193,28.6650338 C32.536,28.563 36,25.035 36,20.667 C36,16.433 32.718,13.058 28.565,12.757 C28.5,12.753 28.443,12.713 28.417,12.653 C26.792,8.797 23.134,6 18.667,6"></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'HeavyRain',
  '0 0 32 29'
);
export const HeavyRainsAtTimes = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-796.000000, -375.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Heavy-Rains-At-Times-40x40"
            transform="translate(585.000000, 0.000000)"
          >
            <path
              d="M24,23.851 L24,32.817 C24,32.918 24.082,33 24.184,33 L26.482,33 C26.584,33 26.667,32.918 26.667,32.817 L26.667,23.851 C26.667,23.749 26.584,23.667 26.482,23.667 L24.184,23.667 C24.082,23.667 24,23.749 24,23.851 M13.333,23.851 L13.333,32.817 C13.333,32.918 13.415,33 13.517,33 L15.816,33 C15.918,33 16,32.918 16,32.817 L16,23.851 C16,23.749 15.918,23.667 15.816,23.667 L13.517,23.667 C13.415,23.667 13.333,23.749 13.333,23.851 M18.667,21.184 L18.667,30.15 C18.667,30.251 18.749,30.334 18.851,30.334 L21.149,30.334 C21.251,30.334 21.333,30.251 21.333,30.15 L21.333,21.184 C21.333,21.082 21.251,21 21.149,21 L18.851,21 C18.749,21 18.667,21.082 18.667,21.184 M18.667,7 C13.899,7 9.886,10.161 8.562,14.434 C8.549,14.477 8.52,14.512 8.479,14.533 C5.836,15.917 4,18.561 4,21.667 C4,26.035 7.464,29.563 11.807,29.6650338 C11.911,29.667 12,29.58 12,29.475 L12,27.176 C12,27.078 11.921,27.001 11.823,26.998 C8.875,26.911 6.667,24.645 6.667,21.667 C6.667,19.417 8.052,17.5 10.125,16.625 L10.75,16.375 L10.917,15.709 C11.703,12.329 14.886,9.667 18.667,9.667 C22.349,9.667 25.297,12.027 26.333,15.375 L26.625,16.334 L27.657,16.334 C31.005,16.334 33.78,19.255 33.265,22.563 C32.871,25.088 30.821,26.919 28.177,26.998 C28.079,27.001 28,27.078 28,27.175 L28,29.475 C28,29.58 28.089,29.667 28.193,29.6650338 C32.535,29.563 36,26.035 36,21.667 C36,17.433 32.718,14.058 28.564,13.757 C28.499,13.753 28.442,13.713 28.417,13.653 C26.792,9.797 23.134,7 18.667,7"
              id="Heavy-Rains-at-Times-40x40"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'HeavyRainsAtTimes',
  '0 0 32 27'
);

export const LightDrizzle = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-1102.000000, -542.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Light-Drizzle-40x40"
            transform="translate(891.764817, 167.971800)"
          >
            <g transform="translate(4.000000, 6.000000)">
              <path
                d="M18.037283,19.395 L18.037283,19.395 C17.403283,19.395 16.889283,19.909 16.889283,20.543 L16.889283,21.309 C16.889283,21.943 17.403283,22.458 18.037283,22.458 C18.672283,22.458 19.186283,21.943 19.186283,21.309 L19.186283,20.543 C19.186283,19.909 18.672283,19.395 18.037283,19.395 M19.952283,24.372 L19.952283,24.372 C19.317283,24.372 18.804283,24.886 18.804283,25.52 L18.804283,26.286 C18.804283,26.92 19.317283,27.434 19.952283,27.434 C20.586283,27.434 21.100283,26.92 21.100283,26.286 L21.100283,25.52 C21.100283,24.886 20.586283,24.372 19.952283,24.372 M14.666283,9.9475983e-14 C9.881283,9.9475983e-14 5.854283,3.184 4.547283,7.482 C4.543283,7.494 4.535283,7.503 4.524283,7.509 C1.516283,9.063 -0.461717003,12.244 0.0932829973,15.886 C0.697282997,19.853 4.311283,22.667 8.324283,22.667 L9.283283,22.667 C9.310283,22.667 9.333283,22.645 9.333283,22.618 L9.333283,20.05 C9.333283,20.023 9.310283,20 9.283283,20 L8.269283,20 C5.412283,20 2.860283,17.873 2.678283,15.021 C2.523283,12.62 3.943283,10.546 6.125283,9.625 L6.750283,9.375 L6.916283,8.708 C7.703283,5.329 10.885283,2.667 14.666283,2.667 C18.349283,2.667 21.427283,5.089 22.333283,8.375 L22.583283,9.333 L23.840283,9.333 C26.688283,9.333 29.175283,11.501 29.324283,14.346 C29.492283,17.541 27.141283,20 24.000283,20 L22.666283,20 L22.666283,22.618 C22.666283,22.645 22.688283,22.667 22.716283,22.667 L23.644283,22.667 C28.016283,22.667 31.846283,19.317 31.995283,14.948 C32.144283,10.556 28.768283,7.022 24.487283,6.752 C24.470283,6.751 24.454283,6.74 24.447283,6.723 C22.920283,2.79 19.156283,9.9475983e-14 14.666283,9.9475983e-14"
                id="Fill-29"
              ></path>
              <path
                d="M13.977783,19.395 L13.977783,19.395 C13.342783,19.395 12.829783,19.909 12.829783,20.543 L12.829783,21.309 C12.829783,21.943 13.342783,22.458 13.977783,22.458 C14.612783,22.458 15.125783,21.943 15.125783,21.309 L15.125783,20.543 C15.125783,19.909 14.612783,19.395 13.977783,19.395 M15.891783,24.372 L15.891783,24.372 C15.257783,24.372 14.743783,24.886 14.743783,25.52 L14.743783,26.286 C14.743783,26.92 15.257783,27.434 15.891783,27.434 C16.526783,27.434 17.040783,26.92 17.040783,26.286 L17.040783,25.52 C17.040783,24.886 16.526783,24.372 15.891783,24.372"
                id="Fill-30"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'LightDrizzle',
  '0 0 33 28'
);

export const LightFreezingRain = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-794.000000, -464.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Light-Freezing-Rain-40x40"
            transform="translate(583.013803, 91.763800)"
          >
            <path
              d="M16.0001967,29 L18.6671967,29 L18.6671967,25 L16.0001967,25 L16.0001967,29 Z M18.6671967,30.581 L18.6671967,34.581 L16.0001967,34.581 L16.0001967,30.581 L18.6671967,30.581 Z M24.0001967,27.914 L24.0001967,31.914 L21.3331967,31.914 L21.3331967,27.914 L24.0001967,27.914 Z M18.6671967,5 C23.1671967,5 26.9381967,7.801 28.4581967,11.75 C33.0011967,12.019 36.5341967,15.965 35.9341967,20.716 C35.4241967,24.752 31.7881967,27.666 27.7211967,27.666 L27.7211967,27.666 L26.6671967,27.666 L26.6671967,25 L28.0001967,25 C31.3221967,25 33.7591967,22.251 33.2721967,18.792 C32.9041967,16.189 30.5361967,14.333 27.9071967,14.333 L27.9071967,14.333 L26.5831967,14.333 L26.3331967,13.375 C25.4271967,10.088 22.3491967,7.666 18.6671967,7.666 C14.8861967,7.666 11.7031967,10.328 10.9171967,13.708 L10.9171967,13.708 L10.7501967,14.375 L10.1251967,14.625 C7.75819671,15.624 6.28719671,17.981 6.75319671,20.643 C7.20219671,23.215 9.58819671,25 12.1981967,25 L12.1981967,25 L13.3331967,25 L13.3331967,27.666 L12.2551967,27.666 C8.53519671,27.666 5.12119671,25.239 4.24019671,21.626 C3.27519671,17.671 5.32019671,14.154 8.54219671,12.5 C9.84419671,8.192 13.8751967,5 18.6671967,5 Z M23.8087967,18.1227 L23.8087967,20.0807 L25.5167967,19.1227 L26.3087967,20.5807 L24.7667967,21.4557 L26.3087967,22.3307 L25.5167967,23.7897 L23.8087967,22.8307 L23.8087967,24.7897 L22.1417967,24.7897 L22.1417967,22.8307 L20.4337967,23.7897 L19.6417967,22.3307 L21.1837967,21.4557 L19.6417967,20.5807 L20.4337967,19.1227 L22.1417967,20.0807 L22.1417967,18.1227 L23.8087967,18.1227 Z"
              id="Fill-18"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'LightFreezingRain',
  '0 0 32 31'
);

export const LightRain = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-794.000000, -542.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Light-Rain-40x40"
            transform="translate(583.013803, 169.813200)"
          >
            <path d="M16.0001967,29 L18.6671967,29 L18.6671967,25 L16.0001967,25 L16.0001967,29 Z M18.6671967,30.581 L18.6671967,34.581 L16.0001967,34.581 L16.0001967,30.581 L18.6671967,30.581 Z M24.0001967,27.915 L24.0001967,31.915 L21.3331967,31.915 L21.3331967,27.915 L24.0001967,27.915 Z M24.0001967,22.333 L24.0001967,26.333 L21.3331967,26.333 L21.3331967,22.333 L24.0001967,22.333 Z M18.6671967,5 C13.8751967,5 9.84419671,8.193 8.54219671,12.5 C5.32019671,14.155 3.27519671,17.672 4.24019671,21.626 C5.12119671,25.241 8.53519671,27.667 12.2551967,27.667 L13.3331967,27.667 L13.3331967,25 L12.1981967,25 C9.58819671,25 7.20219671,23.215 6.75319671,20.644 C6.28719671,17.983 7.75819671,15.624 10.1251967,14.625 L10.7501967,14.375 L10.9171967,13.708 C11.7031967,10.329 14.8861967,7.667 18.6671967,7.667 C22.3491967,7.667 25.4271967,10.089 26.3331967,13.375 L26.5831967,14.333 L27.9071967,14.333 C30.5361967,14.333 32.9041967,16.19 33.2721967,18.792 C33.7591967,22.251 31.3221967,25 28.0001967,25 L26.6671967,25 L26.6671967,27.667 L27.7211967,27.667 C31.7881967,27.667 35.4241967,24.753 35.9341967,20.718 C36.5341967,15.965 33.0011967,12.021 28.4581967,11.75 C26.9381967,7.802 23.1671967,5 18.6671967,5 L18.6671967,5 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'LightRain',
  '0 0 32 31'
);

export const Mist = createSvgIcon(
  <Fragment>
    <defs>
      <polygon
        id="path-1"
        points="0 0.8403 32.0004 0.8403 32.0004 23.5063 0 23.5063"
      ></polygon>
    </defs>
    <g
      id="Homepage_image-ratio-fixed"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
        transform="translate(-211.000000, -540.000000)"
      >
        <g id="Group-46" transform="translate(207.000000, 368.000000)">
          <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
            <g id="Mist-40x40" transform="translate(0.000000, 163.520200)">
              <g transform="translate(4.000000, 8.000000)">
                <mask id="mask-2" fill="white">
                  <use href="#path-1"></use>
                </mask>
                <g id="Clip-2"></g>
                <path
                  d="M21.3334,22.1733 L21.3334,22.1733 C21.3334,22.9093 21.9304,23.5063 22.6664,23.5063 L25.3334,23.5063 C26.0694,23.5063 26.6664,22.9093 26.6664,22.1733 C26.6664,21.4373 26.0694,20.8403 25.3334,20.8403 L22.6664,20.8403 C21.9304,20.8403 21.3334,21.4373 21.3334,22.1733 M10.6664,22.1733 L10.6664,22.1733 C10.6664,22.9093 11.2634,23.5063 11.9994,23.5063 L14.6664,23.5063 C15.4034,23.5063 15.9994,22.9093 15.9994,22.1733 C15.9994,21.4373 15.4034,20.8403 14.6664,20.8403 L11.9994,20.8403 C11.2634,20.8403 10.6664,21.4373 10.6664,22.1733 M-0.0006,22.1733 L-0.0006,22.1733 C-0.0006,22.9093 0.5974,23.5063 1.3334,23.5063 L3.9994,23.5063 C4.7364,23.5063 5.3334,22.9093 5.3334,22.1733 C5.3334,21.4373 4.7364,20.8403 3.9994,20.8403 L1.3334,20.8403 C0.5974,20.8403 -0.0006,21.4373 -0.0006,22.1733 M26.6664,15.5063 L26.6664,15.5063 C26.6664,16.2423 27.2634,16.8403 28.0004,16.8403 L30.6664,16.8403 C31.4034,16.8403 32.0004,16.2423 32.0004,15.5063 C32.0004,14.7703 31.4034,14.1733 30.6664,14.1733 L28.0004,14.1733 C27.2634,14.1733 26.6664,14.7703 26.6664,15.5063 M15.9994,15.5063 L15.9994,15.5063 C15.9994,16.2423 16.5974,16.8403 17.3334,16.8403 L20.0004,16.8403 C20.7364,16.8403 21.3334,16.2423 21.3334,15.5063 C21.3334,14.7703 20.7364,14.1733 20.0004,14.1733 L17.3334,14.1733 C16.5974,14.1733 15.9994,14.7703 15.9994,15.5063 M5.3334,15.5063 L5.3334,15.5063 C5.3334,16.2423 5.9304,16.8403 6.6664,16.8403 L9.3334,16.8403 C10.0694,16.8403 10.6664,16.2423 10.6664,15.5063 C10.6664,14.7703 10.0694,14.1733 9.3334,14.1733 L6.6664,14.1733 C5.9304,14.1733 5.3334,14.7703 5.3334,15.5063 M21.3334,8.8403 L21.3334,8.8403 C21.3334,9.5763 21.9304,10.1733 22.6664,10.1733 L25.3334,10.1733 C26.0694,10.1733 26.6664,9.5763 26.6664,8.8403 C26.6664,8.1043 26.0694,7.5063 25.3334,7.5063 L22.6664,7.5063 C21.9304,7.5063 21.3334,8.1043 21.3334,8.8403 M10.6664,8.8403 L10.6664,8.8403 C10.6664,9.5763 11.2634,10.1733 11.9994,10.1733 L14.6664,10.1733 C15.4034,10.1733 15.9994,9.5763 15.9994,8.8403 C15.9994,8.1043 15.4034,7.5063 14.6664,7.5063 L11.9994,7.5063 C11.2634,7.5063 10.6664,8.1043 10.6664,8.8403 M-0.0006,8.8403 L-0.0006,8.8403 C-0.0006,9.5763 0.5974,10.1733 1.3334,10.1733 L3.9994,10.1733 C4.7364,10.1733 5.3334,9.5763 5.3334,8.8403 C5.3334,8.1043 4.7364,7.5063 3.9994,7.5063 L1.3334,7.5063 C0.5974,7.5063 -0.0006,8.1043 -0.0006,8.8403 M26.6664,2.1733 L26.6664,2.1733 C26.6664,2.9093 27.2634,3.5063 28.0004,3.5063 L30.6664,3.5063 C31.4034,3.5063 32.0004,2.9093 32.0004,2.1733 C32.0004,1.4373 31.4034,0.8403 30.6664,0.8403 L28.0004,0.8403 C27.2634,0.8403 26.6664,1.4373 26.6664,2.1733 M15.9994,2.1733 L15.9994,2.1733 C15.9994,2.9093 16.5974,3.5063 17.3334,3.5063 L20.0004,3.5063 C20.7364,3.5063 21.3334,2.9093 21.3334,2.1733 C21.3334,1.4373 20.7364,0.8403 20.0004,0.8403 L17.3334,0.8403 C16.5974,0.8403 15.9994,1.4373 15.9994,2.1733 M5.3334,2.1733 L5.3334,2.1733 C5.3334,2.9093 5.9304,3.5063 6.6664,3.5063 L9.3334,3.5063 C10.0694,3.5063 10.6664,2.9093 10.6664,2.1733 C10.6664,1.4373 10.0694,0.8403 9.3334,0.8403 L6.6664,0.8403 C5.9304,0.8403 5.3334,1.4373 5.3334,2.1733"
                  fill={palette.common.White}
                  mask="url(#mask-2)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Fragment>,
  'Mist',
  '0 0 32 24'
);

export const ModerateRain = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-1258.000000, -462.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Moderate-rain-40x40"
            transform="translate(1047.517000, 88.166400)"
          >
            <path
              d="M23,24.851 L23,33.817 C23,33.918 23.083,34 23.185,34 L25.483,34 C25.585,34 25.667,33.918 25.667,33.817 L25.667,24.851 C25.667,24.749 25.585,24.667 25.483,24.667 L23.185,24.667 C23.083,24.667 23,24.749 23,24.851 M17.667,22.184 L17.667,31.15 C17.667,31.251 17.749,31.334 17.851,31.334 L20.15,31.334 C20.252,31.334 20.334,31.251 20.334,31.15 L20.334,22.184 C20.334,22.082 20.252,22 20.15,22 L17.851,22 C17.749,22 17.667,22.082 17.667,22.184 M18.667,6 C13.9,6 9.886,9.161 8.562,13.434 C8.55,13.477 8.52,13.512 8.479,13.533 C5.836,14.917 4,17.561 4,20.667 C4,25.035 7.465,28.563 11.807,28.6650338 C11.911,28.667 12,28.58 12,28.475 L12,26.176 C12,26.078 11.922,26.001 11.823,25.998 C8.875,25.911 6.667,23.645 6.667,20.667 C6.667,18.417 8.053,16.5 10.125,15.625 L10.75,15.375 L10.917,14.709 C11.703,11.329 14.886,8.667 18.667,8.667 C22.35,8.667 25.297,11.027 26.334,14.375 L26.625,15.334 L27.658,15.334 C31.006,15.334 33.781,18.255 33.266,21.563 C32.871,24.088 30.822,25.919 28.178,25.998 C28.079,26.001 28,26.078 28,26.175 L28,28.475 C28,28.58 28.09,28.667 28.194,28.6650338 C32.536,28.563 36,25.035 36,20.667 C36,16.433 32.719,13.058 28.565,12.757 C28.5,12.753 28.443,12.713 28.418,12.653 C26.793,8.797 23.135,6 18.667,6"
              id="Fill-17"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'ModerateRain',
  '0 0 33 29'
);

export const ModerateRainAtTimes = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-1258.000000, -462.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Moderate-Rain-at-Times-40x40"
            transform="translate(1047.517000, 88.166400)"
          >
            <path
              d="M23,24.851 L23,33.817 C23,33.918 23.083,34 23.185,34 L25.483,34 C25.585,34 25.667,33.918 25.667,33.817 L25.667,24.851 C25.667,24.749 25.585,24.667 25.483,24.667 L23.185,24.667 C23.083,24.667 23,24.749 23,24.851 M17.667,22.184 L17.667,31.15 C17.667,31.251 17.749,31.334 17.851,31.334 L20.15,31.334 C20.252,31.334 20.334,31.251 20.334,31.15 L20.334,22.184 C20.334,22.082 20.252,22 20.15,22 L17.851,22 C17.749,22 17.667,22.082 17.667,22.184 M18.667,6 C13.9,6 9.886,9.161 8.562,13.434 C8.55,13.477 8.52,13.512 8.479,13.533 C5.836,14.917 4,17.561 4,20.667 C4,25.035 7.465,28.563 11.807,28.6650338 C11.911,28.667 12,28.58 12,28.475 L12,26.176 C12,26.078 11.922,26.001 11.823,25.998 C8.875,25.911 6.667,23.645 6.667,20.667 C6.667,18.417 8.053,16.5 10.125,15.625 L10.75,15.375 L10.917,14.709 C11.703,11.329 14.886,8.667 18.667,8.667 C22.35,8.667 25.297,11.027 26.334,14.375 L26.625,15.334 L27.658,15.334 C31.006,15.334 33.781,18.255 33.266,21.563 C32.871,24.088 30.822,25.919 28.178,25.998 C28.079,26.001 28,26.078 28,26.175 L28,28.475 C28,28.58 28.09,28.667 28.194,28.6650338 C32.536,28.563 36,25.035 36,20.667 C36,16.433 32.719,13.058 28.565,12.757 C28.5,12.753 28.443,12.713 28.418,12.653 C26.793,8.797 23.135,6 18.667,6"
              id="Fill-17"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'ModerateRainAtTimes',
  '0 0 33 29'
);

export const Overcast = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-647.000000, -374.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g id="Overcast-40x40" transform="translate(440.000000, 0.000000)">
            <path d="M32.595,27.286 L31.754,27.286 C31.909,26.663 32,26.014 32,25.341 C32,21.07 28.662,17.674 24.459,17.424 C23.022,13.924 19.912,11.283 16.041,10.771 C17.129,9.31 18.859,8.365 20.769,8.365 C23.01,8.365 25.033,9.612 26.044,11.617 L26.511,12.541 L27.491,12.199 C28.045,12.01 28.553,11.912 29.047,11.912 C31.658,11.912 33.778,14.033 33.778,16.642 C33.778,16.689 33.769,16.73 33.759,16.772 C33.75,16.855 33.741,16.938 33.737,17.016 L33.662,17.867 L34.448,18.204 C36.199,18.948 37.325,20.657 37.325,22.556 C37.325,25.166 35.205,27.286 32.595,27.286 M24,30.674 L8,30.674 C4.964,30.674 2.667,28.377 2.667,25.341 C2.667,23.091 4.053,21.174 6.125,20.299 L6.75,20.049 L6.917,19.383 C7.703,16.002 10.886,13.341 14.667,13.341 C18.35,13.341 21.297,15.7 22.334,19.049 L22.625,20.008 L24,20.008 C27.037,20.008 29.334,22.305 29.334,25.341 C29.334,28.377 27.037,30.674 24,30.674 M36.138,16.407 C36.014,12.605 32.881,9.547 29.047,9.547 C28.585,9.547 28.128,9.599 27.661,9.695 C26.132,7.394 23.574,6 20.769,6 C17.518,6 14.622,7.941 13.284,10.772 C9.115,11.319 5.717,14.289 4.542,18.174 C1.866,19.549 0,22.211 0,25.341 C0,29.773 3.569,33.341 8,33.341 L24,33.341 C26.948,33.341 29.504,31.759 30.893,29.399 C30.926,29.484 30.966,29.565 30.996,29.651 L32.595,29.651 C36.508,29.651 39.691,26.474 39.691,22.556 C39.691,19.997 38.319,17.668 36.138,16.407"></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'Overcast',
  '0 0 40 28'
);

export const PartlyCloudy = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-289.000000, -373.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Partly-Cloudy-40x40"
            transform="translate(77.000000, 0.000000)"
          >
            <path
              d="M23.6669019,11.7148956 C26.7039019,11.7148956 28.9999019,14.0118956 28.9999019,17.0478956 C28.9999019,17.9748956 28.6569019,18.9338956 28.2089019,19.7148956 C27.7969019,19.7398956 27.4329019,19.8918956 27.0419019,19.9648956 C25.9279019,16.6728956 23.2499019,14.1258956 19.8339019,13.3398956 C20.7919019,12.3288956 22.0839019,11.7148956 23.6669019,11.7148956 M23.5419019,5.00589556 C23.4849019,5.01689556 23.4279019,5.03189556 23.3749019,5.04789556 C22.7559019,5.18889556 22.3179019,5.74589556 22.3339019,6.38089556 L22.3339019,7.71489556 C22.3229019,8.36489556 22.7819019,8.92789556 23.4169019,9.04789556 C21.5469019,9.10589556 19.8649019,9.80889556 18.5419019,10.9228956 C18.6569019,10.4278956 18.4799019,9.91189556 18.0839019,9.58989556 L16.9999019,8.50589556 C16.7249019,8.20889556 16.3229019,8.05889556 15.9169019,8.08989556 L15.7919019,8.08989556 C15.2919019,8.17789556 14.8909019,8.54289556 14.7499019,9.02689556 C14.6099019,9.51689556 14.7559019,10.0368956 15.1249019,10.3808956 L16.2089019,11.4648956 C16.5209019,11.8448956 17.0159019,12.0218956 17.4999019,11.9228956 C17.2089019,12.2768956 16.9799019,12.6778956 16.7499019,13.0898956 C12.2399019,13.5008956 8.55290192,16.9538956 7.79190192,21.3808956 C5.77090192,23.0278956 4.52490192,25.6188956 5.17190192,28.6368956 C5.90190192,32.0418956 9.05890192,34.3808956 12.5409019,34.3808956 L14.3339019,34.3808956 L14.3339019,31.7148956 L12.4809019,31.7148956 C10.1229019,31.7148956 8.00490192,30.0298956 7.70790192,27.6918956 C7.45890192,25.7338956 8.36790192,24.0098956 9.74990192,23.0898956 L10.2499019,22.7558956 L10.3339019,22.1308956 C10.7559019,18.7718956 13.5469019,16.0898956 16.9589019,15.7558956 L16.9999019,15.7558956 C17.3229019,15.8868956 17.6779019,15.8868956 17.9999019,15.7558956 L18.0419019,15.7558956 C21.4899019,15.9278956 24.2189019,18.4338956 24.8749019,21.7148956 L25.2089019,23.2978956 L26.7089019,22.6728956 C27.0239019,22.5478956 27.3109019,22.4678956 27.6309019,22.4238956 C30.3339019,22.0518956 32.8969019,24.1358956 32.9969019,26.8618956 C33.0969019,29.5698956 31.0149019,31.7148956 28.3339019,31.7148956 L13.9999019,31.7148956 L13.9999019,34.3808956 L28.0929019,34.3808956 C31.5629019,34.3808956 34.7419019,32.0768956 35.4869019,28.6878956 C36.3209019,24.8928956 34.1689019,21.4598956 30.9589019,20.2148956 C31.3339019,19.3238956 31.5889019,18.3608956 31.6249019,17.3398956 C31.7659019,17.9748956 32.3499019,18.4178956 32.9999019,18.3808956 L34.3339019,18.3808956 C34.8129019,18.3868956 35.2609019,18.1368956 35.5059019,17.7198956 C35.7449019,17.3028956 35.7449019,16.7928956 35.5059019,16.3758956 C35.2609019,15.9588956 34.8129019,15.7088956 34.3339019,15.7148956 L32.9999019,15.7148956 L32.8749019,15.7148956 C32.3229019,15.7398956 31.8389019,16.1058956 31.6669019,16.6308956 C31.5789019,14.8288956 30.8749019,13.2148956 29.7919019,11.9228956 C30.2869019,12.0368956 30.8029019,11.8608956 31.1249019,11.4648956 L32.2089019,10.3808956 C32.6049019,10.0008956 32.7249019,9.41189556 32.5109019,8.90689556 C32.3029019,8.40189556 31.7969019,8.07889556 31.2499019,8.08989556 L31.1249019,8.08989556 C30.8229019,8.13089556 30.5419019,8.28189556 30.3339019,8.50589556 L29.2499019,9.58989556 C28.8699019,9.90289556 28.6929019,10.3968956 28.7919019,10.8808956 C27.4749019,9.78689556 25.7969019,9.11489556 23.9589019,9.04789556 C24.5789019,8.90689556 25.0159019,8.34989556 24.9999019,7.71489556 L24.9999019,6.38089556 C25.0159019,5.99589556 24.8599019,5.62589556 24.5839019,5.36489556 C24.3029019,5.09989556 23.9219019,4.96989556 23.5419019,5.00589556"
              id="Partly-Cloudy-"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'PartlyCloudy',
  '0 0 31 30'
);

export const PatchyFreezingDrizzlePossible = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-949.000000, -466.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Patchy-Freezing-Drizzle-Possible-40x40"
            transform="translate(738.072403, 93.389400)"
          >
            <g transform="translate(4.000000, 5.000000)">
              <path
                d="M14.6671967,1.84741111e-13 C9.87519671,1.84741111e-13 5.84419671,3.193 4.54219671,7.5 C1.32019671,9.155 -0.724803289,12.672 0.240196711,16.627 C1.12119671,20.24 4.53519671,22.667 8.25519671,22.667 L9.33319671,22.667 L9.33319671,20 L8.19819671,20 C5.58819671,20 3.20219671,18.215 2.75319671,15.645 C2.28719671,12.982 3.75819671,10.625 6.12519671,9.625 L6.75019671,9.375 L6.91719671,8.709 C7.70319671,5.328 10.8861967,2.667 14.6671967,2.667 C18.3491967,2.667 21.4271967,5.089 22.3331967,8.375 L22.5831967,9.334 L23.9071967,9.334 C26.5361967,9.334 28.9041967,11.19 29.2711967,13.793 C29.7591967,17.252 27.3221967,20 24.0001967,20 L22.6671967,20 L22.6671967,22.667 L23.7211967,22.667 C27.7871967,22.667 31.4241967,19.753 31.9341967,15.718 C32.5341967,10.966 29.0011967,7.021 24.4581967,6.75 C22.9381967,2.803 19.1671967,1.84741111e-13 14.6671967,1.84741111e-13"
                id="Fill-23"
              ></path>
              <polygon
                id="Fill-24"
                points="16.9845967 12.2413 16.9845967 14.1993 15.2765967 13.2413 14.4845967 14.6993 16.0265967 15.5743 14.4845967 16.4493 15.2765967 17.9083 16.9845967 16.9493 16.9845967 18.9083 18.6515967 18.9083 18.6515967 16.9493 20.3595967 17.9083 21.1515967 16.4493 19.6095967 15.5743 21.1515967 14.6993 20.3595967 13.2413 18.6515967 14.1993 18.6515967 12.2413"
              ></polygon>
              <path
                d="M18.1827967,21.4971 L18.1827967,21.4971 C17.5477967,21.4971 17.0347967,22.0121 17.0347967,22.6451 L17.0347967,23.4111 C17.0347967,24.0461 17.5477967,24.5601 18.1827967,24.5601 C18.8167967,24.5601 19.3307967,24.0461 19.3307967,23.4111 L19.3307967,22.6451 C19.3307967,22.0121 18.8167967,21.4971 18.1827967,21.4971"
                id="Fill-25"
              ></path>
              <path
                d="M14.1222967,21.4971 L14.1222967,21.4971 C13.4882967,21.4971 12.9742967,22.0121 12.9742967,22.6451 L12.9742967,23.4111 C12.9742967,24.0461 13.4882967,24.5601 14.1222967,24.5601 C14.7572967,24.5601 15.2702967,24.0461 15.2702967,23.4111 L15.2702967,22.6451 C15.2702967,22.0121 14.7572967,21.4971 14.1222967,21.4971 M16.0372967,26.4741 L16.0372967,26.4741 C15.4022967,26.4741 14.8882967,26.9881 14.8882967,27.6231 L14.8882967,28.3891 C14.8882967,29.0221 15.4022967,29.5371 16.0372967,29.5371 C16.6712967,29.5371 17.1852967,29.0221 17.1852967,28.3891 L17.1852967,27.6231 C17.1852967,26.9881 16.6712967,26.4741 16.0372967,26.4741"
                id="Fill-26"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'PatchyFreezingDrizzlePossible',
  '0 0 33 30'
);

export const PatchyLightDrizzle = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-653.000000, -468.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Patchy-Light-Drizzle-40x40"
            transform="translate(442.495318, 92.389000)"
          >
            <path
              d="M22.0382815,27.395 L22.0382815,27.395 C21.4042815,27.395 20.8892815,27.91 20.8892815,28.543 L20.8892815,29.309 C20.8892815,29.944 21.4042815,30.458 22.0382815,30.458 C22.6722815,30.458 23.1862815,29.944 23.1862815,29.309 L23.1862815,28.543 C23.1862815,27.91 22.6722815,27.395 22.0382815,27.395 M17.9781815,29.395 L18.1032648,29.401749 C18.6784304,29.4641911 19.1261815,29.9522 19.1261815,30.543 L19.1261815,30.543 L19.1261815,31.309 C19.1261815,31.944 18.6121815,32.458 17.9781815,32.458 C17.3441815,32.458 16.8301815,31.944 16.8301815,31.309 L16.8301815,31.309 L16.8301815,30.543 C16.8301815,29.91 17.3441815,29.395 17.9781815,29.395 L17.9781815,29.395 Z M18.6662815,8 C23.1562815,8 26.9202815,10.79 28.4482815,14.723 C28.4542815,14.741 28.4702815,14.751 28.4882815,14.752 C32.7682815,15.022 36.1452815,18.556 35.9952815,22.949 C35.8462815,27.317 32.0172815,30.667 27.6452815,30.667 L27.6452815,30.667 L26.7162815,30.667 C26.6892815,30.667 26.6662815,30.645 26.6662815,30.618 L26.6662815,30.618 L26.6662815,28 L28.0002815,28 C31.1422815,28 33.4932815,25.541 33.3252815,22.347 C33.1752815,19.501 30.6892815,17.334 27.8402815,17.334 L27.8402815,17.334 L26.5832815,17.334 L26.3332815,16.375 C25.4272815,13.089 22.3492815,10.667 18.6662815,10.667 C14.8852815,10.667 11.7032815,13.329 10.9162815,16.709 L10.9162815,16.709 L10.7502815,17.375 L10.1252815,17.625 C7.94428154,18.546 6.52428154,20.62 6.67828154,23.022 C6.86128154,25.874 9.41328154,28 12.2702815,28 L12.2702815,28 L13.2842815,28 C13.3112815,28 13.3332815,28.023 13.3332815,28.05 L13.3332815,28.05 L13.3332815,30.618 C13.3332815,30.645 13.3112815,30.667 13.2842815,30.667 L13.2842815,30.667 L12.3252815,30.667 C8.31228154,30.667 4.69728154,27.853 4.09328154,23.887 C3.53828154,20.245 5.51628154,17.063 8.52528154,15.509 C8.53628154,15.504 8.54328154,15.495 8.54728154,15.483 C9.85528154,11.185 13.8822815,8 18.6662815,8 Z"
              id="Fill-15"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'PatchyLightDrizzle',
  '0 0 33 25'
);

export const PatchyLightRain = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-653.000000, -549.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Patchy-Light-Rain-40x40"
            transform="translate(442.495683, 173.728500)"
          >
            <path
              d="M18.6663172,26.6657 L18.6663172,31.6657 L15.9993172,31.6657 L15.9993172,26.6657 L18.6663172,26.6657 Z M23.9503172,25.333 C23.9773172,25.333 24.0003172,25.356 24.0003172,25.383 L24.0003172,25.383 L24.0003172,29.283 C24.0003172,29.311 23.9773172,29.333 23.9503172,29.333 L23.9503172,29.333 L21.3823172,29.333 C21.3553172,29.333 21.3333172,29.311 21.3333172,29.283 L21.3333172,29.283 L21.3333172,25.383 C21.3333172,25.356 21.3553172,25.333 21.3823172,25.333 L21.3823172,25.333 Z M18.6663172,8 C13.8813172,8 9.85431719,11.184 8.54631719,15.482 C8.54331719,15.493 8.53531719,15.503 8.52431719,15.509 C5.51531719,17.063 3.53831719,20.243 4.09331719,23.886 C4.69731719,27.853 8.31231719,30.666 12.3243172,30.666 L13.2833172,30.666 C13.3113172,30.666 13.3333172,30.645 13.3333172,30.617 L13.3333172,28.049 C13.3333172,28.022 13.3113172,28 13.2833172,28 L12.2703172,28 C9.41231719,28 6.86031719,25.872 6.67831719,23.021 C6.52331719,20.619 7.94331719,18.545 10.1253172,17.625 L10.7503172,17.375 L10.9163172,16.708 C11.7033172,13.328 14.8853172,10.666 18.6663172,10.666 C22.3493172,10.666 25.4273172,13.088 26.3333172,16.375 L26.5833172,17.333 L27.8393172,17.333 C30.6883172,17.333 33.1753172,19.501 33.3243172,22.346 C33.4923172,25.54 31.1423172,28 28.0003172,28 L26.6663172,28 L26.6663172,30.617 C26.6663172,30.645 26.6883172,30.666 26.7163172,30.666 L27.6453172,30.666 C32.0163172,30.666 35.8463172,27.316 35.9953172,22.947 C36.1453172,18.556 32.7683172,15.022 28.4873172,14.752 C28.4693172,14.75 28.4543172,14.739 28.4473172,14.723 C26.9193172,10.789 23.1563172,8 18.6663172,8"
              id="Fill-12"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'PatchyLightRain',
  '0 0 33 25'
);

export const PatchyRainPossible = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-508.000000, -546.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Patchy-Rain-Possible-40x40"
            transform="translate(297.325803, 172.520200)"
          >
            <path
              d="M16.0001967,34 L18.6671967,34 L18.6671967,26 L16.0001967,26 L16.0001967,34 Z M21.3331967,31.333 L24.0001967,31.333 L24.0001967,23.333 L21.3331967,23.333 L21.3331967,31.333 Z M18.6671967,6 C13.8751967,6 9.84319671,9.193 8.54219671,13.5 C5.32019671,15.155 3.27519671,18.671 4.24019671,22.626 C5.12119671,26.24 8.53519671,28.666 12.2541967,28.666 L13.3331967,28.666 L13.3331967,26 L12.1981967,26 C9.58719671,26 7.20219671,24.214 6.75219671,21.644 C6.28719671,18.982 7.75719671,16.624 10.1251967,15.625 L10.7501967,15.375 L10.9171967,14.708 C11.7031967,11.329 14.8851967,8.666 18.6671967,8.666 C22.3491967,8.666 25.4271967,11.088 26.3331967,14.375 L26.5831967,15.333 L27.9071967,15.333 C30.5361967,15.333 32.9041967,17.19 33.2711967,19.792 C33.7581967,23.251 31.3211967,26 28.0001967,26 L26.6671967,26 L26.6671967,28.666 L27.7201967,28.666 C31.7871967,28.666 35.4231967,25.752 35.9331967,21.717 C36.5331967,16.965 33.0011967,13.02 28.4581967,12.75 C26.9371967,8.802 23.1671967,6 18.6671967,6 L18.6671967,6 Z"
              id="Fill-10"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'PatchyRainPossible',
  '0 0 33 29'
);

export const PatchySleetPossible = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-508.000000, -462.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Patchy-Sleet-Possible-40x40"
            transform="translate(297.325600, 89.763500)"
          >
            <g transform="translate(4.000000, 5.000000)">
              <path
                d="M14.667,-3.71258579e-13 C9.875,-3.71258579e-13 5.844,3.192 4.542,7.5 C1.865,8.875 0,11.536 0,14.666 C0,19.099 3.568,22.666 8,22.666 L8,20 C4.964,20 2.667,17.703 2.667,14.666 C2.667,12.416 4.052,10.5 6.125,9.625 L6.75,9.375 L6.917,8.708 C7.703,5.328 10.886,2.666 14.667,2.666 C18.349,2.666 21.297,5.025 22.334,8.375 L22.625,9.333 L24,9.333 C27.037,9.333 29.334,11.63 29.334,14.666 C29.334,17.703 27.037,20 24,20 L24,22.666 C28.433,22.666 32,19.099 32,14.666 C32,10.396 28.662,7 24.459,6.75 C22.855,2.844 19.172,-3.71258579e-13 14.667,-3.71258579e-13"
                id="Fill-6"
              ></path>
              <polygon
                id="Fill-8"
                points="11.917 10 11.917 13.333 9.042 11.708 8.292 13.083 11.125 14.666 8.292 16.25 9.042 17.625 11.917 16 11.917 19.333 13.417 19.333 13.417 16 16.292 17.625 17.042 16.25 14.209 14.666 17.042 13.083 16.292 11.708 13.417 13.333 13.417 10"
              ></polygon>
              <polygon
                id="Fill-12"
                points="20.0004 29.3333 22.6674 29.3333 22.6674 18.6663 20.0004 18.6663"
              ></polygon>
              <polygon
                id="Fill-14"
                points="14.6674 29.3333 17.3344 29.3333 17.3344 21.3333 14.6674 21.3333"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'PatchySleetPossible',
  '0 0 33 31'
);

export const PatchySnowPossible = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-361.000000, -374.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Patchy-Snow-Possible-40x40"
            transform="translate(150.000000, 0.000000)"
          >
            <g transform="translate(4.000000, 6.000000)">
              <path
                d="M14.667,1.84741111e-13 C9.875,1.84741111e-13 5.844,3.192 4.542,7.5 C1.865,8.875 0,11.536 0,14.667 C0,19.099 3.568,22.667 8,22.667 L8,20 C4.964,20 2.667,17.703 2.667,14.667 C2.667,12.417 4.052,10.5 6.125,9.625 L6.75,9.375 L6.917,8.708 C7.703,5.328 10.886,2.667 14.667,2.667 C18.349,2.667 21.427,5.089 22.334,8.375 L22.584,9.333 L24,9.333 C27.037,9.333 29.334,11.63 29.334,14.667 C29.334,17.703 27.037,20 24,20 L24,22.667 C28.433,22.667 32,19.099 32,14.667 C32,10.396 28.662,7 24.459,6.75 C22.938,2.802 19.167,1.84741111e-13 14.667,1.84741111e-13"
                id="Fill-6"
              ></path>
              <polygon
                id="Fill-8"
                points="10.5836 10 10.5836 13.333 7.7086 11.708 6.9586 13.083 9.7916 14.667 6.9586 16.25 7.7086 17.625 10.5836 16 10.5836 19.333 12.0836 19.333 12.0836 16 14.9586 17.625 15.7086 16.25 12.8756 14.667 15.7086 13.083 14.9586 11.708 12.0836 13.333 12.0836 10"
              ></polygon>
              <polygon
                id="Fill-12"
                points="17.2501 19.333 17.2501 22.667 14.3751 21.042 13.6251 22.417 16.4581 24 13.6251 25.583 14.3751 26.958 17.2501 25.333 17.2501 28.667 18.7501 28.667 18.7501 25.333 21.6251 26.958 22.3751 25.583 19.5421 24 22.3751 22.417 21.6251 21.042 18.7501 22.667 18.7501 19.333"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'PatchySnowPossible',
  '0 0 32 29'
);

export const Sunny = createSvgIcon(
  <Fragment>
    <defs>
      <polygon
        id="path-1"
        points="0.000240216984 0.972 32.149 0.972 32.149 33 0.000240216984 33"
      ></polygon>
    </defs>
    <g
      id="Homepage_image-ratio-fixed"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
        transform="translate(-1242.000000, -821.000000)"
      >
        <g id="Group-46" transform="translate(207.000000, 368.000000)">
          <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
            <g id="Sunny-40x40" transform="translate(1031.000000, 447.971800)">
              <g transform="translate(4.000000, 4.000000)">
                <mask id="mask-2" fill="white">
                  <use href="#path-1"></use>
                </mask>
                <g id="Clip-2"></g>
                <path
                  d="M15.964,27.6488 C15.292,27.7318 14.792,28.3048 14.797,28.9818 L14.797,31.6488 C14.792,32.1278 15.042,32.5758 15.459,32.8208 C15.876,33.0598 16.386,33.0598 16.802,32.8208 C17.219,32.5758 17.469,32.1278 17.464,31.6488 L17.464,28.9818 C17.469,28.5958 17.302,28.2318 17.016,27.9768 C16.73,27.7208 16.344,27.6018 15.964,27.6488 L15.964,27.6488 Z M24.381,24.1898 C23.881,24.2788 23.48,24.6428 23.339,25.1278 C23.198,25.6178 23.344,26.1378 23.714,26.4818 L25.589,28.3568 C26.12,28.8728 26.969,28.8678 27.485,28.3358 C28.001,27.8048 27.995,26.9558 27.464,26.4398 L25.589,24.6068 C25.313,24.3098 24.912,24.1588 24.506,24.1898 L24.381,24.1898 Z M7.422,24.1898 C7.131,24.2428 6.87,24.3878 6.672,24.6068 L4.797,26.4398 C4.266,26.9558 4.261,27.8048 4.776,28.3358 C5.292,28.8678 6.141,28.8728 6.672,28.3568 L8.547,26.4818 C8.98,26.0808 9.094,25.4458 8.834,24.9198 C8.579,24.3878 8.001,24.0958 7.422,24.1898 L7.422,24.1898 Z M27.881,15.6488 C27.146,15.7158 26.605,16.3728 26.672,17.1068 C26.74,17.8408 27.396,18.3828 28.131,18.3148 L30.797,18.3148 C31.277,18.3208 31.724,18.0708 31.969,17.6538 C32.209,17.2368 32.209,16.7268 31.969,16.3098 C31.724,15.8928 31.277,15.6428 30.797,15.6488 L28.131,15.6488 L28.006,15.6488 L27.881,15.6488 Z M1.214,15.6488 C0.48,15.7158 -0.062,16.3728 0.006,17.1068 C0.073,17.8408 0.73,18.3828 1.464,18.3148 L4.131,18.3148 C4.61,18.3208 5.058,18.0708 5.302,17.6538 C5.542,17.2368 5.542,16.7268 5.302,16.3098 C5.058,15.8928 4.61,15.6428 4.131,15.6488 L1.464,15.6488 L1.339,15.6488 L1.214,15.6488 Z M16.131,10.3148 C19.802,10.3148 22.797,13.3098 22.797,16.9818 C22.797,20.6538 19.802,23.6488 16.131,23.6488 C12.459,23.6488 9.464,20.6538 9.464,16.9818 C9.464,13.3098 12.459,10.3148 16.131,10.3148 L16.131,10.3148 Z M16.131,7.6488 C11.006,7.6488 6.797,11.8568 6.797,16.9818 C6.797,22.1068 11.006,26.3148 16.131,26.3148 C21.256,26.3148 25.464,22.1068 25.464,16.9818 C25.464,11.8568 21.256,7.6488 16.131,7.6488 L16.131,7.6488 Z M26.381,5.2318 C26.079,5.2738 25.797,5.4238 25.589,5.6488 L23.714,7.5238 C23.318,7.8458 23.136,8.3618 23.251,8.8618 C23.365,9.3568 23.756,9.7478 24.251,9.8618 C24.751,9.9768 25.266,9.7948 25.589,9.3988 L27.464,7.5238 C27.86,7.1428 27.98,6.5548 27.766,6.0488 C27.558,5.5448 27.052,5.2208 26.506,5.2318 L26.381,5.2318 Z M5.464,5.2318 C4.964,5.3208 4.563,5.6848 4.422,6.1698 C4.282,6.6588 4.427,7.1798 4.797,7.5238 L6.672,9.3988 C6.995,9.7948 7.511,9.9768 8.011,9.8618 C8.506,9.7478 8.896,9.3568 9.011,8.8618 C9.126,8.3618 8.943,7.8458 8.547,7.5238 L6.672,5.6488 C6.422,5.3828 6.079,5.2368 5.714,5.2318 L5.589,5.2318 L5.464,5.2318 Z M15.964,0.9818 C15.292,1.0648 14.792,1.6378 14.797,2.3148 L14.797,4.9818 C14.792,5.4618 15.042,5.9088 15.459,6.1538 C15.876,6.3928 16.386,6.3928 16.802,6.1538 C17.219,5.9088 17.469,5.4618 17.464,4.9818 L17.464,2.3148 C17.469,1.9298 17.302,1.5648 17.016,1.3098 C16.73,1.0548 16.344,0.9348 15.964,0.9818 L15.964,0.9818 Z"
                  fill={palette.common.White}
                  mask="url(#mask-2)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Fragment>,
  'Sunny',
  '0 0 33 32'
);

export const ThunderyOutbreaksPossible = createSvgIcon(
  <g
    id="Homepage_image-ratio-fixed"
    stroke="none"
    strokeWidth="1"
    fill="none"
    fillRule="evenodd"
  >
    <g
      id="01_DCT_Home_Updated-Image-Ratio_desktop-Copy-3"
      transform="translate(-352.000000, -461.000000)"
      fill={palette.common.White}
    >
      <g id="Group-46" transform="translate(207.000000, 368.000000)">
        <g id="Weather-Icons" transform="translate(0.000000, 0.028200)">
          <g
            id="Thundery-Outbreaks-Possible-40x40"
            transform="translate(141.494000, 87.971500)"
          >
            <path d="M20,18.334 L16,27.667 L20,27.667 L20,34.334 L24,25 L20,25 L20,18.334 Z M18.667,5 C13.875,5 9.844,8.193 8.542,12.5 C5.865,13.875 4,16.537 4,19.667 C4,24.1 7.568,27.667 12,27.667 L13.333,27.667 L13.333,25 L12,25 C8.964,25 6.667,22.703 6.667,19.667 C6.667,17.417 8.052,15.5 10.125,14.625 L10.75,14.375 L10.917,13.709 C11.703,10.328 14.886,7.667 18.667,7.667 C22.349,7.667 25.427,10.089 26.333,13.375 L26.583,14.334 L28,14.334 C31.037,14.334 33.333,16.631 33.333,19.667 C33.333,22.703 31.037,25 28,25 L26.667,25 L26.667,27.667 L28,27.667 C32.433,27.667 36,24.1 36,19.667 C36,15.396 32.662,12 28.458,11.75 C26.937,7.803 23.167,5 18.667,5 L18.667,5 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </g>,
  'ThunderyOutbreaksPossible',
  '0 0 33 30'
);
